import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {TabContent, TabPane, Nav, NavItem, NavLink, Row, Col} from 'reactstrap';
import QuantidadePercentualContratacaoProdutoStore from "../stores/QuantidadePercentualContratacaoProdutoStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {CustomPieChart} from "../../comum/components/CustomPieChart";
import {CustomBarChart} from "../../comum/components/CustomBarChart";
import classnames from 'classnames';

const FILTROS = ['AREA', 'CENTRAL', 'DIVISAO', 'DEPARTAMENTO', 'EMPRESA', 'COMPETENCIA_INICIO', 'COMPETENCIA_FIM', 'PRODUTO'];

@inject("store")
@DataWrapper
@observer
export class QuantidadePercentualContratacaoProduto extends Component {
    constructor(props) {
        super(props);
        this.controller = new QuantidadePercentualContratacaoProdutoStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Quantidade e percentual de contratações por projeto/centro de resultado/finalidade");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <MensagemErro>
                        {this.controller.erro}
                    </MensagemErro>
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                history={this.props.history}
                                controller={this.controller}
                                location={this.props.location}
                                fields={FILTROS} />
                        { this.controller.dados && this.controller.dados.length > 0 &&
                            <div>
                                <Nav tabs>
                                    <NavItem>
                                        <NavLink onClick={() => { this.controller.toggle('1'); }}
                                            className={classnames({ active: this.controller.activeTab === '1' })} >
                                            Quantidade
                                        </NavLink>
                                    </NavItem>
                                    <NavItem>
                                        <NavLink onClick={() => { this.controller.toggle('2'); }}
                                            className={classnames({ active: this.controller.activeTab === '2' })} >
                                            Percentual
                                        </NavLink>
                                    </NavItem>
                                    { this.controller.produtoSelecionado &&
                                        <NavItem>
                                            <NavLink onClick={() => { this.controller.toggle('3'); }}
                                                className={classnames({ active: this.controller.activeTab === '3' })}>
                                                {this.controller.produtoSelecionado}
                                            </NavLink>
                                        </NavItem>
                                    }
                                </Nav>
                                <TabContent activeTab={this.controller.activeTab}>
                                    <TabPane tabId="1">
                                        <Row>
                                            <Col xs={12} md={12} lg={10}>
                                                <div className="text-center">Clique na barra referente à projeto/centro de resultado/finalidade para detalhar os projetos/centros de resultado/finalidades</div>
                                                <CustomBarChart dataKeys={["Quantidade"]} data={this.controller.dados}
                                                        onClick={(produto) => this.controller.detalharProduto(produto)} legend={false}
                                                        labelAxisX={"Projeto/centro de resultado/finalidade"} labelAxisY={"Quantidade"} />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="2">
                                        <Row>
                                            <Col xs={12} md={12} lg={10}>
                                                <div className="text-center">Clique na barra referente à projeto/centro de resultado/finalidade para detalhar os projetos/centros de resultado/finalidades</div>
                                                <CustomPieChart dataKey="Quantidade" data={this.controller.dados}
                                                        onClick={(produto) => this.controller.detalharProduto(produto)}/>
                                            </Col>
                                        </Row>
                                    </TabPane>
                                    <TabPane tabId="3">
                                        <Row>
                                            <Col xs={12} md={12} lg={10}>
                                                <div className="text-center">Cargos para a projeto/centro de resultado/finalidade <strong>{this.controller.produtoSelecionado}</strong></div>
                                                <CustomBarChart dataKeys={["Quantidade"]} data={this.controller.detalhes} legend={false}
                                                        labelAxisX={"Cargo"} labelAxisY={"Quantidade"} />
                                            </Col>
                                        </Row>
                                    </TabPane>
                                </TabContent>
                            </div>
                        }
                        { this.controller.dados && this.controller.dados.length === 0 &&
                            <span>Nenhum resultado encontrado</span>
                        }
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}
